/**
 * The purpose of this is to convert any links on the page directing at resource items
 * to links to the files of those resource items, via API.
 * 
 * For example, a link to:
 * .../resource/my-resource
 * 
 * Will be changed to a link to
 * .../wp-content/uploads/x/y/FILENAME
 * 
 * This is to make it easier for content editors to link resources in the WYSIWYG without the
 * need for copy/pasting file links directly.
 */

export default {
  init() {

  },
  finalize() {
    
    const $resource_links = $(`a[href^="${window.location.origin}/resource/"]`);

    if ($resource_links.length > 0) {
      $resource_links.each(function() {
        const $this = $(this);
        $this.addClass('disabled');

        const resource_link = $this.attr('href');
        const resource_link_exploded = resource_link.split('/').reverse();

        var slug = '';
        
        resource_link_exploded.forEach((str) => {
          if (slug == '' && str != '') {
            slug = str;
          }
        });

        // Make API request to get the correct file URL.
        $.ajax({
          url: '/wp-json/resource-link/v1/get',
          method: 'GET',
          data: {
            slug: slug,
          },
        }).done(function(url) {
          $this.attr('href', url);
          $this.removeClass('disabled');
        });
      });
    }

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/resourceLinks.js